import { CustomTable, InputSearchField, UserAvatarWithName } from 'components'
// import { ActionBox } from 'components/ActionBox'
import { GetBlockedViewersList, GetViewersList, useDebounce } from 'hooks'
import React, { useEffect, useState } from 'react'
import { CommonUtility, UsersService } from 'utility'
import { ActionBox } from 'components/ActionBox'

const CommonColumn = [{
    title: 'Viewer Name',
    dataIndex: 'name',
    key: 'name',
    width: 200,
    render: (_, record) => (
        <UserAvatarWithName forViewer id={record.firebase_uid} title={record.name} url={record.photo_url} />
    ),
},
{
    title: 'Phone Number',
    dataIndex: 'phone',
    key: 'phone',
},
{
    title: 'Birth Date',
    dataIndex: 'birth_date',
    key: 'birth_date',
},
{
    title: 'Followings',
    dataIndex: 'following_count',
    key: 'following_count',
    render: value => <span>{CommonUtility.numberFormat(value || 0)}</span>,
},
{
    title: 'Votes',
    dataIndex: 'votes',
    key: 'votes',
    render: value => <span>{CommonUtility.numberFormat(value || 0)}</span>,
},
{
    title: 'Comments',
    dataIndex: 'comments',
    key: 'comments',
    render: value => <span>{CommonUtility.numberFormat(value || 0)}</span>,
}]
export const AllViewersTab = () => {
    const { data: ViewerData, filter, pageChanged, pageSizeChanged, total, loading, updateFilter } =
        GetViewersList()
    const [data, setData] = useState(ViewerData || [])
    const [search, setSearch] = useState()
    const finalSearch = useDebounce(search, 1000)

    useEffect(() => {
        if (finalSearch?.trim() || finalSearch?.trim() === '') {
            updateFilter('search', finalSearch?.trim())
        }
    }, [finalSearch])

    useEffect(() => {
        setData(ViewerData)
    }, [ViewerData])

    const onDelete = async record => {
        await UsersService.deleteUser(record.firebase_uid, false)
        setData(data.filter(ele => ele.firebase_uid !== record.firebase_uid))
    }

    const onBlock = async record => {
        await UsersService.block(record.firebase_uid, !record.isBlocked)
        setData(data.filter(ele => ele.firebase_uid !== record.firebase_uid))
    }
    const columns = [
        ...CommonColumn,
        {
            title: 'Blocked',
            dataIndex: 'isBlocked',
            key: 'isBlocked',
            render: (_, record) => <span>
                <ActionBox item={record} onBlock={() => onBlock(record)} />
            </span>,
        },
        {
            title: 'Action',
            dataIndex: 'Action',
            key: 'Action',
            render: (_, record) => (
                <div className="d-flex">
                    <ActionBox item={record} onDelete={() => onDelete(record)} />
                </div>
            ),
        },
    ]
    return (
        <div>
            <div className="px-5">
                <div className="d-flex justify-content-end">
                    <InputSearchField
                        placeholder="Search here..."
                        onChange={val => setSearch(val)}
                        className="w-25"
                    />
                </div>
                <CustomTable
                    data={data}
                    columns={columns}
                    pageChanged={pageChanged}
                    pageSizeChanged={pageSizeChanged}
                    updateFilter={updateFilter}
                    page={filter.page}
                    pageSize={filter.limit}
                    loading={loading}
                    total={total}
                />
            </div>
        </div>
    )
}

export const BlockedViewersTab = () => {
    const { data: ViewerData, filter, pageChanged, pageSizeChanged, total, loading, updateFilter } =
        GetBlockedViewersList()
    const [data, setData] = useState(ViewerData || [])
    const [search, setSearch] = useState()
    const finalSearch = useDebounce(search, 1000)

    useEffect(() => {
        if (finalSearch?.trim() || finalSearch?.trim() === '') {
            updateFilter('search', finalSearch?.trim())
        }
    }, [finalSearch])

    useEffect(() => {
        setData(ViewerData)
    }, [ViewerData])

    const onDelete = async record => {
        await UsersService.deleteUser(record.firebase_uid, false)
        setData(data.filter(ele => ele.firebase_uid !== record.firebase_uid))
    }

    const onBlock = async record => {
        await UsersService.block(record.firebase_uid, !record.isBlocked)
        setData(data.filter(ele => ele.firebase_uid !== record.firebase_uid))
    }
    const columns = [
        ...CommonColumn,
        {
            title: 'Blocked',
            dataIndex: 'isBlocked',
            key: 'isBlocked',
            render: (_, record) => <span>
                <ActionBox item={record} onBlock={() => onBlock(record)} />
            </span>,
        },
        {
            title: 'Action',
            dataIndex: 'Action',
            key: 'Action',
            render: (_, record) => (
                <div className="d-flex">
                    <ActionBox item={record} onDelete={() => onDelete(record)} />
                </div>
            ),
        },
    ]
    return (
        <div>
            <div className="px-5">
                <div className="d-flex justify-content-end">
                    <InputSearchField
                        placeholder="Search here..."
                        onChange={val => setSearch(val)}
                        className="w-25"
                    />
                </div>
                <CustomTable
                    data={data}
                    columns={columns}
                    pageChanged={pageChanged}
                    pageSizeChanged={pageSizeChanged}
                    updateFilter={updateFilter}
                    page={filter.page}
                    pageSize={filter.limit}
                    loading={loading}
                    total={total}
                />
            </div>
        </div>
    )
}
